/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_cognito_identity_pool_id": "ap-south-1:cda1c5e5-f5cf-40ea-9f87-527095be380c",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_7e0xgcMb6",
    "aws_user_pools_web_client_id": "1vpcuc8qgpvujt8a9vao2oud51",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "devindexing-march-28-2024-prod",
    "aws_content_delivery_bucket_region": "ap-south-1",
    "aws_content_delivery_url": "https://d2ytzr2hchcdj9.cloudfront.net",
    "aws_appsync_graphqlEndpoint": "https://fxuje6r5wbhhpbuuuebgnbn6aa.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-djildkf2brfgxfwbfhpmgdj3uy"
};


export default awsmobile;
